import * as yup from 'yup';
import { getValidationMessages } from '@/common/constants/validation-messages';

const messages = getValidationMessages();

export const PartiesSchema = yup.object().shape({
  party_number: yup.string().required(messages.required),
  place_number: yup.string().required(messages.required),
  capacity: yup.number().required(messages.required),
  crop_type_id: yup.string().required(messages.required),
  generation: yup.string().required(messages.required),
  crop_generation_id: yup.string(),
  cluster_id: yup.string().required(messages.required),
  industrial_grade: yup.number().required(messages.required),
  class: yup.number().required(messages.required),
});
